import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

const Image = ({ queryName, alt, imgClassName }) => {
  const consulta = useStaticQuery(graphql`
    query {

      indexWorldBackground: file(relativePath: { eq: "world-background.jpg" }) {
        childImageSharp {
          fixed(width: 600) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      indexParques: file(relativePath: { eq: "parques.jpg" }) {
        childImageSharp {
          fixed(width: 260) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      indexInvestigacion: file(relativePath: { eq: "investigacion.jpg" }) {
        childImageSharp {
          fixed(width: 260) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      indexIntegracion: file(relativePath: { eq: "integracion.jpg" }) {
        childImageSharp {
          fixed(width: 260) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      indexRecargas: file(relativePath: { eq: "recargas.jpg" }) {
        childImageSharp {
          fixed(width: 260) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      indexSolarCooling: file(relativePath: { eq: "solar-cooling.jpg" }) {
        childImageSharp {
          fixed(width: 260) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      indexHidrogeno: file(relativePath: { eq: "hidrogeno.jpg" }) {
        childImageSharp {
          fixed(width: 260) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      integracion1: file(relativePath: { eq: "integracion-1.jpg" }) {
        childImageSharp {
          fixed(width: 350) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      integracion2: file(relativePath: { eq: "integracion-2.jpg" }) {
        childImageSharp {
          fixed(width: 350) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      integracion3: file(relativePath: { eq: "integracion-3.jpg" }) {
        childImageSharp {
          fixed(width: 350) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      integracionTermica2: file(relativePath: { eq: "termic-2.jpg" }) {
        childImageSharp {
          fixed(width: 325) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      rechargePoint1: file(relativePath: { eq: "recargas-centro-comercial.jpg" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      rechargePoint2: file(relativePath: { eq: "recargas-aparcamiento.jpg" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      rechargePoint3: file(relativePath: { eq: "recargas-acera.jpg" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      rechargePoint4: file(relativePath: { eq: "recargas-estacionamiento-privado.jpg" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      rechargePoint5: file(relativePath: { eq: "recargas-hotel.jpg" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      rechargePoint6: file(relativePath: { eq: "recargas-garaje.jpg" }) {
        childImageSharp {
          fixed(width: 300) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

      hydrogenWebsite: file(relativePath: { eq: "hydrogenium-web.png" }) {
        childImageSharp {
          fixed(width: 450) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }

    }
  `)

  const fixed = consulta[queryName].childImageSharp.fixed

  return (
    <Img fixed={fixed} alt={alt} className={imgClassName} style={{ height: '100%', width: '100%' }} />
  )
  
}

export default Image;
